import { cn } from '@commenda/utils';
import React from 'react';

import { Progress, type ProgressInterface } from '../../Progress';
import { DataGridSemanticIntent } from '../types';

export interface DataGridCellProgressProps {
  value: number;
  intent?: DataGridSemanticIntent;
  label?: React.ReactNode;
  className?: string;
}

const DATA_GRID_CELL_PROGRESS_TRACK_CLASS_NAMES =
  'h-1.5 w-[95px] shrink-0 rounded-xs';

const DATA_GRID_CELL_PROGRESS_VALUE_CLASS_NAMES =
  'txt-small-regular w-[40px] shrink-0 text-right text-text-primary';

const DATA_GRID_CELL_PROGRESS_BAR_HEIGHT = 6;

const DATA_GRID_CELL_PROGRESS_ACCENTS: Record<
  DataGridSemanticIntent,
  NonNullable<ProgressInterface['accent']>
> = {
  neutral: 'default',
  positive: 'success',
  warning: 'warn',
  critical: 'error',
};

const DataGridCellProgress = ({
  value,
  intent = 'neutral',
  label,
  className,
}: DataGridCellProgressProps) => (
  <div
    className={cn('flex w-full items-center justify-end gap-md', className)}
  >
    <Progress
      value={value}
      accent={DATA_GRID_CELL_PROGRESS_ACCENTS[intent]}
      height={DATA_GRID_CELL_PROGRESS_BAR_HEIGHT}
      className={DATA_GRID_CELL_PROGRESS_TRACK_CLASS_NAMES}
    />
    {label ? (
      <span className={DATA_GRID_CELL_PROGRESS_VALUE_CLASS_NAMES}>{label}</span>
    ) : null}
  </div>
);

export { DataGridCellProgress };
